
import Form from 'element-ui/lib/form'

export default {
  name: 'ElNestedForm',
  extends: Form,
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
}
